<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-09 20:41:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/components/SearchNone/index.vue
-->
<template>
  <div class="none font14 font_weight400 colo055">
    您搜索的“<span class="colo087">{{ keyWords }}</span
    >”无结果，试试其他关键字
  </div>
</template>
<script>
export default {
  props: {
    keyWords: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="less" scoped>
.none {
  padding: 20px 0;
}
</style>
